import { shape, string } from 'prop-types'
import { memo, useEffect, useState } from 'react'

import {
  FILTER_FLYOUT_CLOSE,
  PRODUCT_FILTER_CHANGED_SFX,
  PRODUCT_FILTER_RESET_SFX,
} from 'shared/experiments/components/NewSerp/consts'
import store, { subscribe } from 'shared/store'
import { upperCaseFirst } from 'shared/utils/stringUtils'
import InputCheckbox from 'views/components/molecules/InputCheckbox'

const ListItem = ({ item, attribute }) => {
  const { label, count, alternativeLabel, isRefined } = item
  const displayedLabel = alternativeLabel || label
  const componentId = `refinement-control-${attribute}-${displayedLabel}`

  const [isChecked, setIsChecked] = useState(isRefined)

  useEffect(() => {
    setIsChecked(isRefined)
  }, [isRefined])

  useEffect(() => {
    return subscribe.after(`${PRODUCT_FILTER_RESET_SFX}${attribute}`, () =>
      setIsChecked(false)
    )
  }, [attribute])

  useEffect(() => {
    return subscribe.after(FILTER_FLYOUT_CLOSE, payload => {
      if (attribute === payload.attribute) {
        setIsChecked(isRefined)
      }
    })
  }, [attribute, isRefined])

  const handleChange = () => {
    setIsChecked(!isChecked)

    store.dispatch(
      /** @type RefinementListChangeAction */
      {
        type: `${PRODUCT_FILTER_CHANGED_SFX}${attribute}`,
        isChecked: !isChecked,
        selected: item.label,
      }
    )
  }

  return (
    <li
      key={displayedLabel}
      className="e-RefinementList__ListItem u-no-border-radius u-margin-x-small--bottom@medium"
    >
      <InputCheckbox
        id={componentId}
        name={componentId}
        checked={isChecked}
        disableAutoCompleteAndFriends
        labelSize="small"
        onChange={handleChange}
      >
        <span suppressHydrationWarning>
          {upperCaseFirst(displayedLabel)} ({count})
        </span>
      </InputCheckbox>
    </li>
  )
}

ListItem.propTypes = {
  item: shape({}).isRequired,
  attribute: string.isRequired,
}

ListItem.defaultProps = {}

// eslint-disable-next-line react/display-name
export default memo(ListItem, (prevProps, nextProps) => {
  return nextProps.item.isRefined === prevProps.item.isRefined
})
